export const NAVIGATION_URL = 'NAVIGATION_URL';
